import { useRef } from 'react'
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules'
import { Props_SnippetContentImageCarousel } from './ContentImageCarousel.props'
import SwiperControls, { swiperNavigationOptions, swiperPaginationOptions } from '../Shared/SwiperControls/SwiperControls'
import SnippetLink from '../Shared/Link/Link'

const SnippetContentImageCarousel = (props: Props_SnippetContentImageCarousel) => {
    const { snippet, heading, repeatable_entry } = props
    const classSnippetThemeBackground = `snippet-content-image-carousel--theme-background snippet-content-image-carousel--theme-background-${snippet.themeBackground?.value}`
    const classSnippetContentThemeBackground = `snippet-content-image-carousel--theme-content-background snippet-content-image-carousel--theme-content-background-${snippet.themeContentBackground?.value}`
    const classSnippetLayout = `snippet-content-image-carousel--layout-${snippet.layout.value}`
    const classHeadingVisibility: string = heading.visibility?.value === "hidden" ? ` snippet-content-image-carousel__heading--${heading.visibility.value}` : ''
    const snippetRef = useRef<HTMLElement | null>(null)

    const carouselId = "content-image-carousel"

    return (
        <section ref={snippetRef} className={`snippet-content-image-carousel ${classSnippetThemeBackground} ${classSnippetContentThemeBackground} ${classSnippetLayout}`}>
            <div className="snippet-content-image-carousel__container">
                <h2 className={`snippet-content-image-carousel__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                <Swiper
                    className="snippet-content-image-carousel__swiper"
                    modules={[Navigation, Pagination, A11y, Autoplay]}
                    navigation={{
                        ...swiperNavigationOptions,
                        prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                        nextEl: `.swiper-navigation__button-next-${carouselId}`,
                    }}
                    pagination={{
                        ...swiperPaginationOptions,
                        el: `.swiper-pagination-${carouselId}`,
                        clickable: true,
                    }}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    slidesPerView={1}
                    watchOverflow={true}
                    watchSlidesProgress={true}
                >
                    {repeatable_entry.map((entry, index) => (
                        <SwiperSlide key={index} className="snippet-content-image-carousel__swiper-slide">
                            <div className="snippet-content-image-carousel__container-entry">
                                { entry.heading?.value && <h3 className="snippet-content-image-carousel__entry-heading">{entry.heading.value}</h3> }
                                { entry.content?.value && <div className="snippet-content-image-carousel__entry-content">{ CompileMarkdown(entry.content?.value)}</div> }
                                <SnippetLink
                                    linkStyles={entry.linkStyle?.value}
                                    className="snippet-content-image-carousel__entry-link"
                                    url={entry.linkHref?.value}
                                    target={entry.linkTarget?.value}
                                >
                                    {entry.linkContent?.value}
                                </SnippetLink>
                            </div>
                            <img
                                className="snippet-content-image-carousel__entry-image"
                                loading="lazy"
                                width={640}
                                height={640}
                                src={entry.image?.value}
                                alt={entry.alt?.value || ''}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <SwiperControls
                    uniqueId={carouselId}
                    className="snippet-content-image-carousel__controls"
                />
            </div>
        </section>
    )
}

export default SnippetContentImageCarousel